import { createFileRoute, Link } from "@tanstack/react-router";
import { ModuleShell, StatTile } from "@/components/intel/ModuleShell";
import { AppLayout } from "@/components/intel/Layout";
import { Users, ShieldCheck, Shield, Mail } from "lucide-react";
import { useAuth } from "@/lib/auth/AuthContext";
import { useInvestigations } from "@/lib/intel/store";

export const Route = createFileRoute("/team")({
  head: () => ({ meta: [{ title: "Analysts · CARIO INTEL" }] }),
  component: TeamPage,
});

function TeamPage() {
  const { user, isAdmin } = useAuth();
  const { state } = useInvestigations();
  const myCases = state.cases.length;
  const role = isAdmin ? "Administrator" : "OSINT Analyst";
  const clearance = isAdmin ? "TS/SCI" : "RESTRICTED";
  return (
    <AppLayout>
    <ModuleShell
      eyebrow="Analysts"
      title="Operator workspace"
      description="Your operator profile and active workload. Additional operators appear here once they accept their invitation."
      meta={isAdmin ? (
        <Link to="/admin" className="inline-flex items-center gap-2 rounded-md border border-amber/40 bg-amber/10 px-3 py-1.5 text-xs text-amber hover:bg-amber/20">
          <Shield className="h-3.5 w-3.5" /> Manage invitations
        </Link>
      ) : null}
    >
      <div className="grid gap-3 md:grid-cols-4">
        <StatTile label="Signed in" value={user ? "1" : "0"} tone="success" />
        <StatTile label="Your cases" value={myCases} tone="cyan" />
        <StatTile label="Evidence" value={state.evidence.length} tone="amber" />
        <StatTile label="Clearance" value={clearance} tone="cyan" />
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <div className="glass rounded-xl p-4">
          <div className="flex items-start gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-md bg-cyan/10 ring-1 ring-cyan/30"><Users className="h-5 w-5 text-cyan" /></div>
            <div className="flex-1 min-w-0">
              <h2 className="font-display text-xl truncate">{user?.email ?? "Operator"}</h2>
              <div className="text-sm text-muted-foreground">{role}</div>
              <div className="mt-1 flex items-center gap-1 font-mono text-[10px] text-muted-foreground"><Mail className="h-3 w-3" />{user?.email}</div>
              <div className="mt-3 flex flex-wrap gap-2 font-mono text-[10px] uppercase tracking-widest">
                <span className="rounded-sm bg-cyan/10 px-2 py-1 text-cyan ring-1 ring-cyan/30"><ShieldCheck className="mr-1 inline h-3 w-3" />{clearance}</span>
                <span className="rounded-sm bg-background/40 px-2 py-1 text-muted-foreground ring-1 ring-panel-border">{myCases} cases</span>
                <span className="rounded-sm bg-success/10 px-2 py-1 text-success ring-1 ring-success/30">online</span>
              </div>
            </div>
          </div>
        </div>
        <div className="glass rounded-xl p-4 border border-dashed border-panel-border text-sm text-muted-foreground">
          Additional operators will appear here automatically once they accept their invitation.
          {isAdmin && <> Use <Link to="/admin" className="text-cyan hover:underline">Control Room → Invitations</Link> to invite analysts.</>}
        </div>
      </div>
    </ModuleShell>
    </AppLayout>
  );
}